import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=e6e18f6c&scoped=true&"
import script from "./Label.vue?vue&type=script&lang=js&"
export * from "./Label.vue?vue&type=script&lang=js&"
import style0 from "./Label.vue?vue&type=style&index=0&id=e6e18f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e18f6c",
  null
  
)

export default component.exports